import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fechaFormatoDt'
})
export class FechaFormatoDtPipe implements PipeTransform {

  transform(value: any): any {

    let fecha: string = ''

    if(value){
      fecha = value.replace(/T+[^\n]+/g,"");
    }

    return fecha;
  }

}
